/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_Crm_AnswerInputs */

const en_landing_faq_crm_answer = /** @type {(inputs: Landing_Faq_Crm_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Inginuiti maps research insights to client profiles and drafts outreach - a chat message or an email - ready for your Sales or Trading desk. The salesperson stays the final decision-maker, reviewing and sending the draft themselves, so every client touchpoint stays human-led and compliant.`)
};

/**
* | output |
* | --- |
* | "Yes. Inginuiti maps research insights to client profiles and drafts outreach - a chat message or an email - ready for your Sales or Trading desk. The salespe..." |
*
* @param {Landing_Faq_Crm_AnswerInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_faq_crm_answer = /** @type {((inputs?: Landing_Faq_Crm_AnswerInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_Crm_AnswerInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_faq_crm_answer(inputs)
});